<template>
  <Modal v-model="model" :title="title" :width="width" :mask-closable="false" @on-visible-change="bindGetData">
    <Spin size="large" fix v-if="loading" />
    <!-- 预算 -->
    <Form v-if="type === 'budget'" inline :label-width="80" @submit.native.prevent>
      <FormItem label="预算">
        <RadioGroup v-model="mode" vertical>
          <Radio label="NONE"><span>不限</span></Radio>
          <Radio label="BUDGET" :disabled="isNobid">
            <InputNumber
              v-model="current"
              :min="100"
              :max="100000000"
              :step="100"
              :precision="3"
              :disabled="mode === 'NONE'"
              :active-change="false"
              size="small"
              placeholder="请输入预算金额"
              style="width: 250px"
            />
          </Radio>
        </RadioGroup>
      </FormItem>
    </Form>
    <!-- 原生广告 -->

    <div v-else-if="type === 'native'">
      <NativeAd :form="data"></NativeAd>
    </div>
    <!-- 试玩 -->
    <Form v-else-if="type === 'play'" :label-width="80" @submit.native.prevent>
      <FormItem label="搭配试玩">
        <RadioGroup v-model="playable" type="button" @on-change="handlePlayable">
          <Radio :label="0">不启用</Radio>
          <Radio :label="1">启用</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="选择试玩" v-if="playable">
        <auto-complete v-model="current" :data="drops" :width="180" placeholder="全部" @on-select="handlePlay" />
      </FormItem>
      <FormItem label="试玩按钮" v-if="playable">
        <Select v-model="play_button" style="width: 180px">
          <Option v-for="(item, id) of playBtns" :key="id" :value="item">{{ item }}</Option>
        </Select>
      </FormItem>
    </Form>
    <!-- 常规 -->
    <div v-else class="c-box">
      <Input v-model="keyword" search placeholder="请输入关键词" />
      <div class="c-content">
        <Row>
          <Col :span="colSpan">
            <div class="c-head">
              <span>{{ name }}列表</span>
              <span class="tag-title" v-show="type === 'retarget'">排除</span>
              <span class="tag-title" v-show="type === 'retarget'">定向</span>
              <span class="tag-title" v-show="type === 'retarget'">{{ attribe }}</span>
              <span class="tag-title" v-show="type === 'retarget'">ID</span>
              <span class="tag-title tag-title-a" v-show="type === 'pagespec'" @click="current = ''">清除</span>
              <Dropdown class="tag-title tag-title-a" v-show="type === 'profile'" placement="bottom-end" @on-click="changeCardType">
                <a href="javascript:void(0)">{{ cardType(card) }}<Icon type="ios-arrow-down"></Icon></a>
                <DropdownMenu slot="list">
                  <DropdownItem name="101" :selected="card === '101'">多利益卡-图文</DropdownItem>
                  <DropdownItem name="102" :selected="card === '102'">多利益卡-多标签</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <div class="c-body">
              <div v-if="!drops.length" class="no-data">
                <Icon type="ios-filing-outline" size="58" color="#efefef" />
                <span>暂无数据</span>
              </div>
              <template v-else-if="type === 'retarget'">
                <div v-for="item in drops" :key="item.id" class="c-check-item g-clearfix">
                  <span class="m-span">{{ item.name }}</span>
                  <span class="item-type">{{ item.id }}</span>
                  <span class="item-type">{{ attriVal(item) }}</span>
                  <RadioGroup v-model="item.select" style="width: 64px; float: right; line-height: 36px">
                    <Radio label="include" style="margin-right: 8px" :disabled="mutex(item)"></Radio>
                    <Radio label="exclude" style="margin-right: 8px" :disabled="item.source === 7 || mutex(item)"></Radio>
                  </RadioGroup>
                  <span v-if="mutex(item)" class="m-cataract c-include c-disabled"></span>
                  <span v-else class="m-cataract c-include" @click.stop="changeRetarget(item, 'include')"></span>
                  <span v-if="item.source === 7 || mutex(item)" class="m-cataract c-exclude c-disabled"></span>
                  <span v-else class="m-cataract c-exclude" @click.stop="changeRetarget(item, 'exclude')"></span>
                </div>
              </template>
              <RadioGroup v-model="current" vertical v-else-if="type === 'target'" class="c-item-radia-group">
                <Radio v-for="r in drops" :label="r.index" :key="r.index">{{ r.targetingName }}</Radio>
              </RadioGroup>
              <RadioGroup v-model="current" vertical v-else-if="type === 'creative'" class="c-item-radia-group">
                <Radio v-for="r in drops" :label="r.index" :key="r.index">{{ r.ideaName }}</Radio>
              </RadioGroup>
              <RadioGroup v-model="current" vertical v-else-if="type === 'pagespec'" class="c-item-radia-group" style="width: 100%">
                <template v-for="r in drops">
                  <Row :key="r.index">
                    <Col span="20"
                      ><Radio :label="r.index">{{ r.page_name }}</Radio></Col
                    >
                    <Col span="4" class="c-item-preview">
                      <a :href="r.preview_url" target="_blank" rel="noopener noreferrer"> 浏览 </a>
                      <a :href="r.preview_url" target="_blank" rel="noopener noreferrer">
                        <Icon type="md-document" color="#5489F2" size="20" />
                      </a>
                    </Col>
                  </Row>
                </template>
              </RadioGroup>
              <el-checkbox-group v-model="current" v-else-if="type === 'profile'" class="c-item-radia-group" style="width: 100%">
                <Row v-for="r in drops" class="profile-item" :key="r.adv_card_id">
                  <Col span="12">
                    <el-checkbox :label="r.adv_card_id" :disabled="current && current.length > 2 && !current.includes(r.adv_card_id)">
                      <img v-if="r.url" :src="r.url" width="25" height="25" />
                      <span style="margin-left: 6px">{{ r.title }}</span>
                    </el-checkbox>
                  </Col>
                  <Col span="8">
                    <span style="margin-left: 8px">{{ r.template_name }}</span>
                  </Col>
                </Row>
              </el-checkbox-group>
              <RadioGroup v-model="current" vertical v-else-if="type === 'convert'" class="c-item-radia-group">
                <Radio v-for="r in drops" :label="r.index" :key="r.index">
                  {{ r.convert_source_type | sourceType }} —— {{ r.convert_type | convType }}{{ r.deep_external_action | convDeepType }}
                  <span
                    v-if="r.deep_external_action === 'AD_CONVERT_TYPE_PURCHASE_ROI'"
                    style="color: #ff4400; margin-top: -15px; padding-left: 22px; font-size: 12px; display: block"
                  >
                    (白名单功能，未开通的账号请勿选择，否则会报错）
                  </span>
                </Radio>
              </RadioGroup>
              <RadioGroup v-model="current" vertical v-else class="c-item-radia-group">
                <Radio v-for="r in drops" :label="r.index" :key="r.index">{{ r.name }}</Radio>
              </RadioGroup>
            </div>
          </Col>
          <Col span="8" v-if="type === 'retarget'">
            <div class="m-box c-result-box">
              <span class="c-retarget-clear" @click="$emit('on-clear', { type })">清空全部</span>
              <Tabs v-model="currenTab" size="small">
                <TabPane :label="`定向${includes.length ? '(' + includes.length + ')' : ''}`" class="c-retarget-result" name="include">
                  <div v-for="item in includes" :key="item.id" class="c-pop-tip">
                    <Tag :name="item.id" class="c-tag-item" closable @on-close="handleClose">{{ item.name }}</Tag>
                  </div>
                </TabPane>
                <TabPane :label="`排除${excludes.length ? '(' + excludes.length + ')' : ''}`" class="c-retarget-result" name="exclude">
                  <div v-for="item in excludes" :key="item.id" class="c-pop-tip">
                    <Tag :name="item.id" class="c-tag-item" closable @on-close="handleClose">{{ item.name }}</Tag>
                  </div>
                </TabPane>
              </Tabs>
            </div>
          </Col>
        </Row>
      </div>
    </div>

    <template slot="footer">
      <Button type="default" @click="$emit('input', false)">取消</Button>
      <Button type="primary" @click="ok">确定</Button>
    </template>
  </Modal>
</template>
<script>
import { getSession, div } from '@/common/js/api'
import { isArray, isEmpty, deepCopy } from '@/common/js/utils'
import { toCountCrowd } from '@/common/js/filters'
import { audienceEnum } from '@/data/kuaishou/datas'
import AutoComplete from '@/components/autocomplete/autocomplete'
import NativeAd from './native-ad'

export default {
  name: 'setBatch',
  components: {
    AutoComplete,
    NativeAd
  },
  props: {
    value: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    type: {
      type: String
    },
    data: {
      type: [Array, Object]
    },
    media: {
      type: [Number, String]
    },
    card: {
      type: [Number, String]
    },
    currents: {
      type: Array
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    drops() {
      if (isArray(this.data)) {
        const drops = this.data
          .filter((ret) => {
            const keyword = String(this.keyword)
            if (keyword && this.type === 'target') return ret.targetingName.includes(keyword)
            else if (keyword && this.type === 'creative') return ret.ideaName.includes(keyword)
            else if (keyword && this.type === 'pagespec') return ret.page_name.includes(keyword)
            else if (keyword && this.type === 'profile') return ret.profile_name.includes(keyword)
            else if (keyword && (this.type === 'convert' || this.type === 'play')) return true
            else if (keyword) return ret.name.includes(keyword)
            else {
              return true
            }
          })
          .map((met, i) => {
            return Object.assign(met, { index: i })
          })
        return drops
      } else return []
    },
    includes() {
      if (!isArray(this.drops)) return []
      return this.drops.filter((ret) => ret.select === 'include')
    },
    excludes() {
      if (!isArray(this.drops)) return []
      return this.drops.filter((ret) => ret.select === 'exclude')
    },
    title() {
      return `请选择${this.name}`
    },
    cardType() {
      return (type) => {
        if (type === '101') return '多利益卡-图文'
        else if (type === '102') return '多利益卡-多标签'
        else return ''
      }
    },
    name() {
      let name = ''
      switch (this.type) {
        case 'account':
          name = '计划账号'
          break
        case 'campaign':
          name = '计划组'
          break
        case 'target':
          name = '定向包'
          break
        case 'retarget':
          name = '人群包'
          break
        case 'creative':
          name = '创意组'
          break
        case 'pagespec':
          name = '落地页'
          break
        case 'play':
          name = '试玩素材'
          break
      }
      return name
    },
    conversion() {
      return this.data.pricing === 'PRICING_OCPM'
    },
    smartConversion() {
      return this.data.smart_bid_type === 'SMART_BID_CONSERVATIVE'
    },
    showBid() {
      return (this.smartConversion && this.data.adjust_cpa) || !this.smartConversion
    },
    deepBid() {
      return this.data.deep_bid_type === 'DEEP_BID_MIN' || this.data.deep_bid_type === 'AUTO_MIN_SECOND_STAGE'
    },
    attribe() {
      if (this.media === 16) return '覆盖数量'
      else return '属性'
    },
    attriVal() {
      return (item) => {
        if (this.media === 16) return toCountCrowd(item.count)
        else return audienceEnum[item.source] || '未知'
      }
    },
    mutex() {
      return ({ source, third_platform_code }) => {
        const isCodeSame = this.includes.some((ret) => ret.select && ret.source === 7 && ret.third_platform_code !== third_platform_code)
        const isIncludesPayBag = this.includes.some((ret) => ret.select && ret.source === 7 && source !== 7)
        const isExcludes = this.excludes.some((ret) => ret.select && ret.source === 7 && source !== 7)
        const isUnIncludesPayBag = this.includes.some((ret) => ret.select && ret.source !== 7 && source === 7)
        const isUnExcludesPayBag = this.excludes.some((ret) => ret.select && source === 7)
        return isIncludesPayBag || isUnIncludesPayBag || isExcludes || isUnExcludesPayBag || isCodeSame
      }
    },
    isNobid() {
      // 判断是否是最大转化
      if (getSession('bid_type')) return getSession('bid_type').bid_type === 1
      else if (getSession('campaign_params')) return getSession('campaign_params').bid_type === 1
      else return false
    }
  },
  data() {
    return {
      keyword: '',
      current: '',
      playable: null,
      play_button: '',
      playBtns: [],
      mode: '', // 预算模式
      currenTab: 'include',
      colSpan: 24,
      width: 620
    }
  },
  methods: {
    bindGetData(val) {
      if (this.type === 'retarget') {
        this.currenTab = 'include'
        this.colSpan = 16
        this.width = 720
      } else {
        this.colSpan = 24
        this.width = 620
      }
      if (val) {
        this.keyword = ''
        if (this.type === 'budget') {
          const data = deepCopy(this.data)
          const { value, mode } = data.pop()
          this.current = value
          this.mode = mode
        } else if (this.type === 'pagespec') {
          const pages = this.data.filter((ret) => ret.check).pop()
          this.current = pages ? pages.index : ''
          this.mode = ''
        } else if (this.type === 'profile') {
          this.current = this.currents
          this.mode = ''
        } else if (this.type === 'play') {
          this.playable = Number(isArray(this.currents) && Boolean(this.currents.length))
          if (this.playable) {
            const [id, button] = this.currents
            this.current = id
            this.play_button = button
          }
          this.mode = ''
        } else {
          this.current = ''
          this.mode = ''
        }
      }
    },
    changeDeepCpabidRange(val) {
      if (val) {
        this.data.deep_cpabid_num_range = ['', '']
        this.data.deep_cpabid = ''
      }
    },
    // 自动出价类型
    smartBidChange(val) {
      if (val === 'SMART_BID_CONSERVATIVE') {
        this.data.schedule_type = 'SCHEDULE_FROM_NOW'
      }
      this.data.adjust_cpa = 0
      this.data.deep_bid_type = 'DEEP_BID_DEFAULT'
      this.data.deep_cpabid_range = 0
      this.data.deep_cpabid = ''
      this.data.bid_range = 0
      this.data.cpa_bid = ''
    },
    changeAdjustCpa(val) {
      this.data.cpa_bid = ''
      this.data.bid_range = 0
    },
    changeDeepBid(val) {
      if (val === 'DEEP_BID_MIN' || val === 'AUTO_MIN_SECOND_STAGE') this.data.deep_cpabid = ''
      else this.data.deep_cpabid = undefined
    },
    changeBidRange(val) {
      if (val) {
        this.data.bid_num_range = ['', '']
        this.data.bid = ''
        this.data.cpa_bid = ''
      }
    },
    changeRetarget(item, type) {
      const check = item.select
      if (type === check) this.$set(item, 'select', null)
      else this.$set(item, 'select', type)
    },
    handlePlay(meta) {
      this.current = meta ? meta.id : ''
    },
    handlePlayable(val) {
      const play_pop = deepCopy(this.playBtns).shift()
      this.play_button = val ? play_pop : ''
      this.current = ''
    },
    handleClose(e, name) {
      this.$emit('on-delete', { type: this.type, name })
    },
    changeCardType(name) {
      this.$emit('on-card', name)
    },
    ok() {
      const retarget = this.drops.some((ret) => {
        return ret.select === 'include' || ret.select === 'exclude'
      })
      if (this.type === 'retarget') {
        if (!retarget) {
          this.$Modal.confirm({
            title: '系统提示',
            content: `<p>您还未选择${this.name}，该操作将清除原已配置的人群包，确认该操作吗？</p>`,
            onOk: () => {
              this.submit(0)
            }
          })
        } else this.submit(0)
      } else if (this.type === 'budget') {
        if (this.mode === 'BUDGET' && !this.current) {
          this.$Message.error('预算范围 100-100,000,000元')
          return
        }
        this.submit({ value: this.current, mode: this.mode })
      } else if (this.type === 'bid') {
        const err = []
        if (this.data.bid_range) {
          // 随机定价
          const [min, max] = this.data.bid_num_range
          if (isEmpty(min) || isEmpty(max)) err.push({ feild: '目标转化出价', msg: '随机目标转化出价不能为空' })
          else if (
            this.data.pricing === 'PRICING_OCPM' &&
            !(this.data.smart_bid_type === 'SMART_BID_CONSERVATIVE' && this.data.adjust_cpa === 0) &&
            (min < 0.1 || max > 10000)
          ) {
            err.push({ feild: '转化出价', msg: '出价范围：0.1~10000（元）' })
          } else if (this.data.pricing === 'PRICING_CPC' && (min < 0.2 || max > 100)) {
            err.push({ feild: '点击出价', msg: '出价范围：0.2~100（元）' })
          } else if (this.data.pricing === 'PRICING_CPM' && (min < 4 || max > 100)) {
            err.push({ feild: '展示出价', msg: '出价范围：4~100（元）' })
          }
          if (max > this.data.budget) err.push({ feild: '转化出价', msg: '随机出价不能大于预算值' })
        } else {
          // 出价设置
          const bid = this.data.bid
          const cpa_bid = this.data.cpa_bid
          if (
            this.data.pricing === 'PRICING_OCPM' &&
            !(this.data.smart_bid_type === 'SMART_BID_CONSERVATIVE' && this.data.adjust_cpa === 0) &&
            !(cpa_bid >= 0.1 && cpa_bid <= 10000)
          ) {
            err.push({ feild: '转化出价', msg: '出价范围：0.1~10000（元）' })
          } else if (this.data.pricing === 'PRICING_CPC' && !(bid >= 0.2 && bid <= 100)) {
            err.push({ feild: '点击出价', msg: '出价范围：0.2~100（元）' })
          } else if (this.data.pricing === 'PRICING_CPM' && !(bid >= 4 && bid <= 100)) {
            err.push({ feild: '展示出价', msg: '出价范围：4~100（元）' })
          }
          if (cpa_bid > this.data.budget) err.push({ feild: '转化出价', msg: '不能大于预算值' })
        }
        if (this.data.deep_cpabid_range) {
          const [min, max] = this.data.deep_cpabid_num_range
          if (isEmpty(min) || isEmpty(max)) err.push({ feild: '深度转化出价', msg: '随机深度转化出价不能为空' })
        } else if (this.data.deep_bid_type === 'ROI_COEFFICIENT') {
          if (isEmpty(this.data.roi_goal)) {
            err.push({ feild: 'ROI系数', msg: 'ROI系数不能为空' })
          } else {
            const roi = Number(this.data.roi_goal)
            const min = 0
            const max = 5
            if (roi <= min || roi > max) err.push({ feild: 'ROI系数', msg: `ROI系数应大于${min}，小于等于${max}` })
          }
        } else {
          // 深度优化出价
          if (
            (this.data.deep_bid_type === 'DEEP_BID_MIN' || this.data.deep_bid_type === 'AUTO_MIN_SECOND_STAGE') &&
            isEmpty(this.data.deep_cpabid)
          ) {
            err.push({ feild: '深度优化出价', msg: '深度转化出价不能为空' })
          }
        }

        if (err.length) {
          const shift = err.shift()
          this.$Message.error(`${shift.feild}${shift.msg}`)
          // 如果错误中断
          return
        }
        this.submit(this.data)
      } else if (this.type === 'profile') {
        if (!isArray(this.current) || (isArray(this.current) && this.current.length < 3)) {
          this.$Message.error('至少选择 3 项多利益卡！')
          return
        }
        this.submit(this.current)
      } else if (this.type === 'play') {
        if (this.playable && isEmpty(this.current)) {
          this.$Message.error('试玩游戏不能为空！')
          return
        }
        this.submit(this.playable ? [this.current, this.play_button] : [])
      } else if (this.type === 'native') {
        const { enable, nativeId } = this.data
        if (enable && !nativeId) {
          this.$Message.error('请选择头像与昵称')
          return
        }
        this.submit(this.data)
      } else {
        if (typeof this.current !== 'number') {
          this.$Message.error(`您还未选择${this.name}`)
          return
        }
        this.submit(this.current)
      }
    },
    submit(index) {
      this.$emit('on-select', { type: this.type, index })
      this.$emit('input', false)
    }
  },
  filters: {
    sourceType(cell) {
      return cell === 'AD_CONVERT_SOURCE_TYPE_APP_DOWNLOAD' ? '应用下载API' : '应用下载SDK'
    },
    convType(cell) {
      if (cell === 'AD_CONVERT_TYPE_ACTIVE') return '激活'
      else if (cell === 'AD_CONVERT_TYPE_PAY') return '付费'
      else if (cell === 'AD_CONVERT_TYPE_ACTIVE_REGISTER') return '注册'
      else if (cell === 'AD_CONVERT_TYPE_GAME_ADDICTION') return '关键行为'
    },
    convDeepType(cell) {
      if (cell === 'AD_CONVERT_TYPE_ACTIVE_REGISTER') return '，深度转化，注册'
      else if (cell === 'AD_CONVERT_TYPE_PAY') return '，深度转化，付费'
      else if (cell === 'AD_CONVERT_TYPE_NEXT_DAY_OPEN') return '，深度转化，次留'
      else if (cell === 'AD_CONVERT_TYPE_PURCHASE_ROI') return '，深度转化，付费ROI'
      else if (cell === '') return '，深度转化，无'
      else return ''
    }
  }
}
</script>
<style lang="scss" scoped>
.c-box {
  position: relative;

  .c-content {
    margin-top: 12px;
    border: solid 1px #dee4f5;
    border-radius: 3px;
    font-size: 14px;

    .c-head {
      line-height: 32px;
      background-color: #fafbfe;
      padding-left: 12px;
      border-bottom: solid 1px #dee4f5;

      .tag-title {
        float: right;
        font-size: 12px;
        margin-right: 14px;
      }

      .tag-title-a {
        color: #5489f2;
        cursor: pointer;
      }
    }

    .c-body {
      overflow-y: auto;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;
      max-height: 365px;
      min-height: 120px;

      .ivu-radio-wrapper {
        font-size: 13px;

        ::v-deep .ivu-radio {
          margin-right: 8px;
        }
      }

      .no-data {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        span {
          color: #c1c1c1;
        }
      }

      .c-item-radia-group {
        padding: 8px 0 8px 12px;
      }

      .profile-item {
        line-height: 32px;
      }

      .c-item-preview {
        display: flex;
        align-items: center;
        justify-content: center;

        a {
          padding: 0 4px;

          &:first-child {
            line-height: 30px;
          }

          &:last-child {
            line-height: 1.2;
          }

          &.del-profile {
            display: none;
            line-height: 30px;
          }
        }
      }

      .c-check-item {
        margin: 0;
        padding-left: 12px;
        display: flex;
        position: relative;
        align-items: center;
        height: 36px;
        width: 100%;

        &:hover {
          background-color: #f8f8f8;
        }

        .m-span {
          width: calc(100% - 180px);
          display: inline-block;
          line-height: 1;
        }

        .item-type {
          text-align: right;
          display: inline-block;
          width: 60px;
          padding-right: 10px;
          font-size: 12px;
        }

        .ivu-radio-group {
          width: 70px !important;
        }

        .ivu-radio-wrapper {
          min-width: inherit;
          text-align: right;
          font-size: 0;
          margin-right: 14px;
        }

        .m-cataract {
          position: absolute;
          width: 18px;
          height: 36px;
          cursor: pointer;
          user-select: none;
          top: 0;

          &.c-disabled {
            cursor: not-allowed;
          }
        }

        .c-include {
          right: 46px;
        }

        .c-exclude {
          right: 16px;
        }
      }
    }

    .c-result-box {
      position: relative;

      ::v-deep.ivu-tabs-bar {
        background-color: #fafbfe;
        margin-bottom: 0;
      }

      .c-retarget-clear {
        width: 60px;
        height: 34px;
        line-height: 34px;
        position: absolute;
        z-index: 8;
        right: 0;
        top: 0;
        display: block;
        color: #598fe6;
        text-align: center;
        cursor: pointer;
        font-size: 12px;
      }

      .c-retarget-result {
        overflow-y: auto;
        scrollbar-width: thin;
        -webkit-overflow-scrolling: touch;
        height: 365px;
        padding-bottom: 8px;

        .c-tag-item {
          margin: 8px 12px 0;
          padding: 2px 6px;
          display: block;
          height: 28px;

          ::v-deep .ivu-tag-text {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            width: 88%;
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
    }
  }
}

.ivu-form-inline .ivu-form-item {
  display: block;
}

::v-deep .row-item {
  align-items: flex-start;

  .item-field {
    line-height: 32px;
  }
}

::v-deep .upload-image {
  width: 1000%;
  overflow: hidden;

  .c-wrap {
    width: 100%;
    max-width: 340px;

    .c-complete {
      width: 150px;
      height: 100px;
      background-color: #efefef;

      img {
        border-radius: 4px;
      }

      .m-image-box {
        width: 150px;
        height: 100px;
      }
    }

    .c-init {
      width: 100px;
      height: 100px;
      cursor: pointer;
      border-style: dashed;
      border-width: 1px;
      border-color: #4b77ee;
      border-radius: 4px;
      text-align: center;

      i,
      span {
        color: #4b77ee;
      }

      .min-column {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100px;
        height: 100px;
        margin: 0 auto;

        span {
          display: inline-block;
          width: 30px;
        }
      }
    }

    ::v-deep.ivu-upload-select {
      width: 100%;
      height: 100%;
      cursor: pointer;
      user-select: none;
    }
  }

  .c-message {
    line-height: 1.2;
    margin-top: 12px;

    i {
      display: inline-block;
    }

    .c-info {
      margin-left: 5px;
    }
  }
}
</style>
